/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Box, Card, CardContent, Link, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import Constants from "../../constants";
import { useCloud } from "../../Hooks/Cloud";
import { formatDateTime } from "../../Utils/Utility";
import "./HistoryItem.css";

/**
 * HistoryItem component
 * Description - This component is used to display the history items
 */
function HistoryItem({ history }) {
  const { cloud } = useCloud();
  const features = window.ENV[cloud].features;

  return (
    <Stack>
      <Card elevation={ 0 } variant="elevation">
        <CardContent className="history-content" sx={ { p: 0 } }>

          { /* Specify short description */ }
          <Link
            href={ features.incident && history.expanded ? `/incidents/${history.id}` : "#" }
            component={ features.incident && history.expanded ? "a" : "div" }
            underline={ features.incident && history.expanded ? "hover" : "none" }
            // color={ Constants.color[history.type] }
            color = "text.primary"
          >
            <Typography variant="body1" fontWeight={ "500" } component="div">
              { history.short_description }
            </Typography>
          </Link>

          { /* Specify outage type & status */ }
          <Typography variant="body2">

            { /* Specify outage type */ }
            { /* <Typography
              component={ "span" }
              fontWeight={ "light" }
              color={ Constants.color[history.type] }
              variant="inherit">
              { history.type }
            </Typography>
            <Typography component={ "span" } variant="inherit">
              &nbsp;|&nbsp;
            </Typography> */ }

            { /* Specify status */ }
            <Typography component={ "span" } variant="inherit">
              Status:&nbsp;
              <Box component={ "span" } color={ Constants.color[history.status] }>
                { history.status }
              </Box>
            </Typography>
          </Typography>

          { /* Specify begin time */ }
          <Typography variant="body2" color="text.secondary">
            { formatDateTime(history.begin) } { (history.status == "Resolved") && (
              <span>&ndash; { history.end ? formatDateTime(history.end) : "" }</span>
            ) }
          </Typography>

          { features.incident && history.expanded && (
            <Box sx={ { my: 1 } }>
              <Link href={ `/incidents/${history.id}` } underline="hover" variant="body2">
                View More
              </Link>
            </Box>
          ) }
        </CardContent>
      </Card>
    </Stack>
  );
}

HistoryItem.propTypes = {
  history: PropTypes.object
};

export default HistoryItem;
